import React from 'react';
import { ItemPredicate } from '@blueprintjs/select';
import { FormTemplateOption } from 'data/template/template.types';

export const itemPredicate: ItemPredicate<FormTemplateOption> = (query, item, _index, exactMatch) => {
  const normalizedLabel = item.label.toLocaleLowerCase();
  const normalizedQuery = query.toLocaleLowerCase();

  if (exactMatch) {
    return normalizedLabel === normalizedQuery;
  }

  return `${normalizedLabel}`.indexOf(normalizedQuery) >= 0;
};

const escapeRegExpChars = (text: string): string => {
  return text.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
};

export const highlightText = (text: string, query: string): React.ReactNode[] => {
  let lastIndex = 0;
  const words = query
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map(escapeRegExpChars);

  if (words.length === 0) {
    return [text];
  }

  const regexp = new RegExp(words.join('|'), 'gi');
  const tokens: React.ReactNode[] = [];

  while (true) {
    const match = regexp.exec(text);
    if (!match) {
      break;
    }

    const { length } = match[0];
    const before = text.slice(lastIndex, regexp.lastIndex - length);
    if (before.length > 0) {
      tokens.push(before);
    }

    lastIndex = regexp.lastIndex;
    tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
  }

  const rest = text.slice(lastIndex);

  if (rest.length > 0) {
    tokens.push(rest);
  }

  return tokens;
};
